import { render, staticRenderFns } from "./UiMessage.vue?vue&type=template&id=6c114bc4&"
import script from "./UiMessage.vue?vue&type=script&lang=js&"
export * from "./UiMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports